// Module
var code = "<svg viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.938 10.84 8.366 7.068a.206.206 0 0 0-.303 0 .235.235 0 0 0 0 .32L11.483 11l-3.42 3.613a.235.235 0 0 0 0 .32.204.204 0 0 0 .302 0l3.572-3.774a.234.234 0 0 0 .001-.319z\" fill=\"#fff\"/></svg>";
// Exports
module.exports = code;